import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FilterEnumsService {
  
  constructor() {
    // Service constructor
  }

  /**
   * Get asset type options for admin activities page
   */
  getAssetTypeOptions(): string[] {
    return ['Dataset', 'Model', 'Usecase'];
  }

  /**
   * Get asset type options for user activities page
   */
  getUserActivitiesAssetTypeOptions(): string[] {
    return ['Dataset', 'Model', 'Usecase'];
  }

  /**
   * Get activity options (sorted alphabetically)
   */
  getActivityOptions(): string[] {
    // Keep dropdown values aligned with backend `action` query param.
    return [
      'View',
      'Download',
      'Upload',
      'Create',
      'Update',
      'Delete',
      'Download Access Granted',
      'Download Access Withdrawn',
      'Download Access Rejected',
      'Download Access Requested'
    ];
  }

  /**
   * Map display asset type to API format
   */
  mapAssetTypeToApi(displayType: string): string {
    const mapping: Record<string, string> = {
      'Dataset': 'DATABANK',
      'Model': 'AI_MODEL',
      'Usecase': 'USECASE'
    };
    return mapping[displayType] || displayType.toUpperCase();
  }

  /**
   * Map display activity to API format
   */
  mapActivityToApi(displayActivity: string): string {
    // Activities are already in the correct format, just uppercase
    return displayActivity.toUpperCase();
  }

  /**
   * Check if asset type should be excluded
   */
  isExcludedAssetType(type: string): boolean {
    const excludedTypes = ['Challenge', 'Data bank', 'Org request'];
    return excludedTypes.includes(type);
  }
}